import React from "react";
import {
  Button,
  Form,
  Container,
  Row,
  Col,
  Modal,
  Card,
} from "react-bootstrap";
import Pagination from "rc-pagination";
import "rc-pagination/assets/index.css";
import localeInfo from "rc-pagination/lib/locale/en_US";
import { ENV } from "../../config/config";

const EventModal = ({
  isOpenModal,
  setOpenModal,
  setEvent,
  events,
  pagination,
  onPageChange,
  reset,
  applyFilters,
  filters,
  setFilters,
  resetButton,
}) => {
  return (
    <Container fluid>
      <Modal
        className="modal-primary custom-modal"
        onHide={() => setOpenModal(!isOpenModal)}
        show={isOpenModal}
      >
        <Modal.Header className="justify-content-center">
          <Row>
            <div className="col-12">
              <h4 className="mb-0 mb-md-3 mt-0">Events</h4>
            </div>
          </Row>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col md={6} style={{ marginTop: "10px" }}>
              <Form.Group>
                <Form.Control
                  value={filters.title}
                  type="text"
                  placeholder="Search with title..."
                  onChange={(e) =>
                    setFilters({ ...filters, title: e.target.value })
                  }
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group>
                <Button className="btn-filled mr-3 mt-1" onClick={applyFilters}>
                  Search
                </Button>
                {resetButton && (
                  <Button
                    style={{ marginTop: "8px" }}
                    variant="warning"
                    className="outline-button"
                    onClick={reset}
                  >
                    Reset
                  </Button>
                )}
              </Form.Group>
            </Col>
          </Row>
          <div className="card-responsive">
            <Row>
              {events && events.length ? (
                events.map((item, index) => {
                  return (
                    <Col md="3" key={index}>
                      <Card
                        className="custom-card"
                        style={{ width: "18rem", border: "solid", cursor: "pointer" }}
                        onClick={() => {
                          setEvent(item);
                          setOpenModal(!isOpenModal);
                        }}
                      >
                        <Card.Img
                          variant="top"
                          src={ENV.assetsUrl + "gallery/" + item.imageUrl}
                        />
                        <Card.Body>
                          <Card.Title>{item.title}</Card.Title>
                        </Card.Body>
                      </Card>
                    </Col>
                  );
                })
              ) : (
                <div className="alert alert-info" role="alert">
                  No Events Found
                </div>
              )}
            </Row>
          </div>
        </Modal.Body>
        <Modal.Footer>
          {pagination && (
            <Pagination
              className="m-3"
              defaultCurrent={1}
              pageSize={pagination.limit}
              current={pagination.page}
              total={pagination.total} // Pagination in RTK usually has total
              onChange={onPageChange}
              locale={localeInfo}
            />
          )}
          <Button
            className="outline-button"
            onClick={() => setOpenModal(!isOpenModal)}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
};

export default EventModal;
